import { useState, useRef, useEffect } from 'react';
import './activity-count-rotator.scss';

const ActivityCountRotator = ({
  datasets,
  onChange,
  totalChangeCount,
  rotateInterval,
  totalCountDataChanged
}) => {
  const [cursor, setCursor] = useState(0);
  const cursorRef = useRef();
  const intervalRef = useRef();

  const resetRotateInterval = () => {
    clearInterval(intervalRef.current);
    if (+rotateInterval) {
      intervalRef.current = setInterval(() => onChevronUpClick(), rotateInterval * 1000);
    }
  };
  
  const onChevronDownClick = () => {
    const newCursor = cursorRef.current >= datasets.length || datasets.length === cursorRef.current + 1  ? 0 : cursorRef.current + 1;
    setCursor(newCursor);
    resetRotateInterval();
  };
  
  const onChevronUpClick = () => {
    const newCursor = cursorRef.current === 0 ? datasets.length - 1 : cursorRef.current - 1;
    setCursor(newCursor);
    resetRotateInterval();
  };

  useEffect(() => {
    setCursor(0);
  }, [datasets]);

  useEffect(() => {
    cursorRef.current = cursor;
  }, [cursor]);
  
  useEffect(() => {
    onChange(!datasets[cursor] ? '' : datasets[cursor].value);
  }, [cursor, datasets, onChange]);

  useEffect(() => {
    if (!rotateInterval || !totalCountDataChanged) {
      return;
    }
    if (+rotateInterval) {
      intervalRef.current = setInterval(() => {
        const newCursor = cursorRef.current >= datasets.length || datasets.length === cursorRef.current + 1  ? 0 : cursorRef.current + 1;
        setCursor(newCursor);
      }, rotateInterval * 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [rotateInterval, datasets, totalCountDataChanged]);

  return (
    <div className="activity-count__changes--wrapper">
      <div className="activity-count_counter-switch--wrapper">
        {
          datasets.length > 1 && (
            <div className="chevrons--wrapper">
              <span
                className='g-icon g-icon-chevron-down chevron-up'
                onClick={onChevronUpClick}
              />
              <span
                className='g-icon g-icon-chevron-down chevron-down'
                onClick={onChevronDownClick}
              />
            </div>
          )
        }
        <p className="selected-counter_text">
          {datasets[cursor]?.label}
        </p>
      </div>
      <p className="activity-count_count">Total: <span>{totalChangeCount}</span></p>
    </div>
  );
};

export default ActivityCountRotator;